import { render, staticRenderFns } from "./featured-resource-select-widget.vue?vue&type=template&id=5136ae43&"
import script from "./featured-resource-select-widget.vue?vue&type=script&lang=js&"
export * from "./featured-resource-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./featured-resource-select-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports